export default __webpack_public_path__ + "static/UTA_MediaLink_logo_BLACK-4a37aa8f9abb5ec0e55632f4dc394378.png";